import React from "react";

const money = (amount, currency = "AED") => {
  if (amount == null || amount === "") return "-";
  return `${currency} ${amount}`;
};

const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const collectRateRequests = (item) => {
  if (!item) return [];
  const history = Array.isArray(item.rate_request_history) ? item.rate_request_history : [];
  if (history.length > 0) return history;
  return item.rate_request_data ? [item.rate_request_data] : [];
};

export const quoteSummary = (data) => {
  if (!data) return { lane: "-", total: "-", courier: "-" };
  const ship = data.shipment || {};
  const q = data.selected_quote || {};
  const pay = data.payment_summary || {};
  const lane = `${ship.origin_city || ship.origin || "-"} → ${ship.destination_city || ship.destination || "-"}`;
  const total =
    pay.total_payable != null && pay.total_payable !== ""
      ? `${pay.currency || "AED"} ${pay.total_payable}`
      : q.total_amount != null && q.total_amount !== ""
        ? `${q.currency || "AED"} ${q.total_amount}`
        : "-";
  return {
    lane,
    total,
    courier: q.courier || q.service || "-",
  };
};

export const SingleRequestPanel = ({ data, index, totalCount }) => {
  if (!data) return null;

  const {
    shipment,
    selected_quote,
    payment_summary,
    all_quotes,
    all_quotes_count,
    quotes_by_type,
    requested_at,
    submitted_at,
    request_id,
  } = data;
  const receivedQuotes = Array.isArray(all_quotes) ? all_quotes : [];
  const selectedId = selected_quote && selected_quote.id;
  const pay = payment_summary || {};
  const summary = quoteSummary(data);

  return (
    <div
      style={{
        marginBottom: "16px",
        background: "#fff",
        borderRadius: "10px",
        border: index === 0 ? "2px solid #038559" : "1px solid #dee2e6",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          padding: "12px 16px",
          background: index === 0 ? "#e8f8ef" : "#f8f9fa",
          borderBottom: "1px solid #e9ecef",
          display: "flex",
          justifyContent: "space-between",
          gap: "12px",
          flexWrap: "wrap",
          alignItems: "center",
        }}
      >
        <div>
          <strong style={{ fontSize: "13px" }}>
            Request #{totalCount - index}
            {index === 0 ? " (Latest)" : ""}
          </strong>
          <span style={{ marginLeft: "10px", fontSize: "12px", color: "#495057", fontWeight: 600 }}>
            {summary.lane}
          </span>
        </div>
        <div style={{ fontSize: "12px", color: "#6c757d" }}>
          {formatDate(submitted_at || requested_at)}
          {request_id ? ` · ${request_id}` : ""}
        </div>
      </div>

      <div style={{ padding: "16px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "12px" }}>
          <div style={{ border: "1px solid #dee2e6", borderRadius: "8px", padding: "12px" }}>
            <h6 style={{ fontWeight: "700", color: "#495057", marginBottom: "10px", fontSize: "12px" }}>
              Shipment requested
            </h6>
            <table style={{ width: "100%", fontSize: "12px" }}>
              <tbody>
                <tr>
                  <td style={{ color: "#6c757d", paddingBottom: "5px" }}>Origin</td>
                  <td style={{ fontWeight: 600, paddingBottom: "5px" }}>
                    {shipment?.origin_city || shipment?.origin || "-"}
                    {shipment?.origin_country ? `, ${shipment.origin_country}` : ""}
                  </td>
                </tr>
                <tr>
                  <td style={{ color: "#6c757d", paddingBottom: "5px" }}>Destination</td>
                  <td style={{ fontWeight: 600, paddingBottom: "5px" }}>
                    {shipment?.destination_city || shipment?.destination || "-"}
                    {shipment?.destination_country ? `, ${shipment.destination_country}` : ""}
                  </td>
                </tr>
                <tr>
                  <td style={{ color: "#6c757d", paddingBottom: "5px" }}>Weight</td>
                  <td style={{ fontWeight: 600, paddingBottom: "5px" }}>
                    {shipment?.total_weight != null ? `${shipment.total_weight} kg` : "-"}
                  </td>
                </tr>
                <tr>
                  <td style={{ color: "#6c757d", paddingBottom: "5px" }}>Goods value</td>
                  <td style={{ fontWeight: 600, paddingBottom: "5px" }}>
                    {shipment?.total_value != null ? `AED ${shipment.total_value}` : "-"}
                  </td>
                </tr>
              </tbody>
            </table>
            {Array.isArray(shipment?.items) && shipment.items.length > 0 && (
              <div style={{ marginTop: "8px", maxHeight: "110px", overflowY: "auto", fontSize: "11px" }}>
                {shipment.items.map((it, idx) => (
                  <div key={idx} style={{ borderTop: "1px solid #f1f3f5", padding: "4px 0" }}>
                    {it.name || "Item"} · Qty {it.quantity || 1} · Wt {it.weight || 0} · Val {it.value || 0}
                  </div>
                ))}
              </div>
            )}
          </div>

          <div style={{ border: "1px solid #28a745", borderRadius: "8px", padding: "12px" }}>
            <h6 style={{ fontWeight: "700", color: "#0f5132", marginBottom: "10px", fontSize: "12px" }}>
              Selected quote
            </h6>
            {selected_quote ? (
              <table style={{ width: "100%", fontSize: "12px" }}>
                <tbody>
                  <tr>
                    <td style={{ color: "#6c757d", paddingBottom: "5px" }}>Mode</td>
                    <td style={{ fontWeight: 700, paddingBottom: "5px", textTransform: "uppercase" }}>
                      {selected_quote.type || "-"}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ color: "#6c757d", paddingBottom: "5px" }}>Service</td>
                    <td style={{ fontWeight: 700, paddingBottom: "5px" }}>
                      {selected_quote.courier || selected_quote.service || "-"}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ color: "#6c757d", paddingBottom: "5px" }}>Delivery</td>
                    <td style={{ fontWeight: 600, paddingBottom: "5px" }}>
                      {selected_quote.delivery_type || "-"}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ color: "#6c757d", paddingBottom: "5px" }}>Freight</td>
                    <td style={{ fontWeight: 600, paddingBottom: "5px" }}>
                      {money(
                        selected_quote.freight_charge || selected_quote.total_amount,
                        selected_quote.currency
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ color: "#6c757d", paddingBottom: "5px" }}>Transit</td>
                    <td style={{ fontWeight: 600, paddingBottom: "5px" }}>
                      {selected_quote.transit_days || "-"}
                    </td>
                  </tr>
                </tbody>
              </table>
            ) : (
              <p style={{ color: "#6c757d", fontSize: "12px", margin: 0 }}>No selected quote</p>
            )}
          </div>

          <div
            style={{
              border: "1px solid #0d6efd",
              borderRadius: "8px",
              padding: "12px",
              background: "#f8fbff",
            }}
          >
            <h6 style={{ fontWeight: "700", color: "#084298", marginBottom: "10px", fontSize: "12px" }}>
              Amount to pay
            </h6>
            <table style={{ width: "100%", fontSize: "12px" }}>
              <tbody>
                <tr>
                  <td style={{ color: "#6c757d", paddingBottom: "5px" }}>Goods value</td>
                  <td style={{ fontWeight: 600, paddingBottom: "5px", textAlign: "right" }}>
                    {money(pay.goods_value ?? shipment?.total_value, pay.currency)}
                  </td>
                </tr>
                <tr>
                  <td style={{ color: "#6c757d", paddingBottom: "5px" }}>Freight</td>
                  <td style={{ fontWeight: 600, paddingBottom: "5px", textAlign: "right" }}>
                    {money(
                      pay.freight ?? selected_quote?.freight_charge ?? selected_quote?.total_amount,
                      pay.currency
                    )}
                  </td>
                </tr>
                {Number(pay.freight_discount) > 0 && (
                  <tr>
                    <td style={{ color: "#6c757d", paddingBottom: "5px" }}>Discount</td>
                    <td style={{ fontWeight: 600, paddingBottom: "5px", textAlign: "right", color: "#dc3545" }}>
                      - {money(pay.freight_discount, pay.currency)}
                    </td>
                  </tr>
                )}
                <tr>
                  <td style={{ color: "#6c757d", paddingBottom: "5px" }}>Insurance</td>
                  <td style={{ fontWeight: 600, paddingBottom: "5px", textAlign: "right" }}>
                    {money(pay.insurance, pay.currency)}
                    {pay.insurance_included === false ? " (off)" : ""}
                  </td>
                </tr>
                <tr>
                  <td style={{ color: "#6c757d", paddingBottom: "5px" }}>
                    Duty{pay.duty_terms ? ` (${pay.duty_terms})` : ""}
                  </td>
                  <td style={{ fontWeight: 600, paddingBottom: "5px", textAlign: "right" }}>
                    {pay.duty_display &&
                    pay.duty_display !== `AED ${Number(pay.duty || 0).toFixed(2)}`
                      ? pay.duty_display
                      : money(pay.duty, pay.currency)}
                  </td>
                </tr>
                {(Number(pay.platform_fee) > 0 || Number(pay.additional_charges) > 0) && (
                  <tr>
                    <td style={{ color: "#6c757d", paddingBottom: "5px" }}>Other fees</td>
                    <td style={{ fontWeight: 600, paddingBottom: "5px", textAlign: "right" }}>
                      {money(
                        Number(pay.platform_fee || 0) + Number(pay.additional_charges || 0),
                        pay.currency
                      )}
                    </td>
                  </tr>
                )}
                <tr>
                  <td style={{ color: "#0f5132", paddingTop: "8px", fontWeight: 800 }}>Total payable</td>
                  <td
                    style={{
                      fontWeight: 800,
                      paddingTop: "8px",
                      textAlign: "right",
                      color: "#198754",
                      fontSize: "15px",
                    }}
                  >
                    {money(pay.total_payable, pay.currency || "AED")}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div style={{ marginTop: "14px" }}>
          <h6 style={{ fontWeight: "700", color: "#495057", marginBottom: "8px", fontSize: "12px" }}>
            All rates received ({receivedQuotes.length || all_quotes_count || 0})
          </h6>
          {quotes_by_type && (
            <div style={{ fontSize: "11px", color: "#6c757d", marginBottom: "8px" }}>
              Courier: {quotes_by_type.courier || 0} · Air: {quotes_by_type.air || 0} · Sea:{" "}
              {quotes_by_type.sea || 0} · Land:{" "}
              {(quotes_by_type.land || 0) + (quotes_by_type.landExpress || 0)}
            </div>
          )}
          {receivedQuotes.length === 0 ? (
            <p style={{ color: "#6c757d", fontSize: "12px", margin: 0 }}>
              Quote list not stored on this older request — send a new request to capture full rates.
            </p>
          ) : (
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", fontSize: "12px", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ background: "#f8f9fa", borderBottom: "1px solid #dee2e6" }}>
                    <th style={{ padding: "8px", textAlign: "left" }}>Mode</th>
                    <th style={{ padding: "8px", textAlign: "left" }}>Courier / Service</th>
                    <th style={{ padding: "8px", textAlign: "left" }}>Delivery</th>
                    <th style={{ padding: "8px", textAlign: "right" }}>Amount</th>
                    <th style={{ padding: "8px", textAlign: "right" }}>Transit</th>
                    <th style={{ padding: "8px", textAlign: "center" }}>Choice</th>
                  </tr>
                </thead>
                <tbody>
                  {receivedQuotes.map((q, idx) => {
                    const isSelected =
                      (selectedId && q.id && q.id === selectedId) ||
                      (selected_quote &&
                        !selectedId &&
                        q.courier === selected_quote.courier &&
                        String(q.total_amount) === String(selected_quote.total_amount));
                    return (
                      <tr
                        key={q.id || idx}
                        style={{
                          borderBottom: "1px solid #f1f3f5",
                          background: isSelected ? "#e8f8ef" : "transparent",
                        }}
                      >
                        <td style={{ padding: "8px", textTransform: "uppercase", fontWeight: 600 }}>
                          {q.type || "-"}
                        </td>
                        <td style={{ padding: "8px", fontWeight: isSelected ? 700 : 500 }}>
                          {q.courier || q.service || "-"}
                        </td>
                        <td style={{ padding: "8px" }}>{q.delivery_type || "-"}</td>
                        <td style={{ padding: "8px", textAlign: "right", fontWeight: 700, color: "#0f5132" }}>
                          {money(q.total_amount, q.currency)}
                        </td>
                        <td style={{ padding: "8px", textAlign: "right" }}>{q.transit_days || "-"}</td>
                        <td style={{ padding: "8px", textAlign: "center" }}>
                          {isSelected ? (
                            <span
                              style={{
                                background: "#d1e7dd",
                                color: "#0f5132",
                                borderRadius: "10px",
                                padding: "2px 8px",
                                fontWeight: 700,
                                fontSize: "11px",
                              }}
                            >
                              Selected
                            </span>
                          ) : (
                            "-"
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

/**
 * Rate approval profile block — shows all rate requests for a retailer.
 * Optional focusRequestId highlights that request first.
 */
export const RateRequestProfile = ({ item, title, focusRequestId, showOnlyFocused }) => {
  let requests = collectRateRequests(item);
  if (focusRequestId && requests.length) {
    const focused = requests.find(
      (r) => r && (r.request_id === focusRequestId || String(r.request_id) === String(focusRequestId))
    );
    if (showOnlyFocused && focused) {
      requests = [focused];
    } else if (focused) {
      requests = [focused, ...requests.filter((r) => r !== focused)];
    }
  }
  const status = (item && item.rate_approval_status) || "pending";

  const statusMap = {
    requested: { bg: "#fff3cd", color: "#856404", label: "Requested" },
    pending: { bg: "#f8d7da", color: "#842029", label: "Not requested" },
    rejected: { bg: "#fde8e8", color: "#9b1c1c", label: "Needs update" },
    approved: { bg: "#d1e7dd", color: "#0f5132", label: "Approved" },
  };
  const statusStyle = statusMap[status] || statusMap.pending;
  const totalAll = collectRateRequests(item).length;

  return (
    <div className="card p-3 h-100" style={{ marginTop: showOnlyFocused ? 0 : "16px" }}>
      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
        <div>
          <div className="fs-5 fw-bold mb-1">{title || "Rate Approval Profile"}</div>
          <div style={{ fontSize: "13px", color: "#6c757d" }}>
            {showOnlyFocused
              ? "Details for this rate request (shipment, quotes, duty, insurance, total payable)"
              : "All freight rate requests sent by this retailer (lane, quotes, duty, insurance, total payable)"}
          </div>
        </div>
        <div style={{ display: "flex", gap: "8px", alignItems: "center", flexWrap: "wrap" }}>
          <span
            style={{
              background: statusStyle.bg,
              color: statusStyle.color,
              borderRadius: "12px",
              padding: "4px 12px",
              fontSize: "12px",
              fontWeight: 700,
            }}
          >
            {statusStyle.label}
          </span>
          <span
            style={{
              background: "#e7f1ff",
              color: "#084298",
              borderRadius: "12px",
              padding: "4px 12px",
              fontSize: "12px",
              fontWeight: 700,
            }}
          >
            {showOnlyFocused
              ? `1 of ${totalAll} request${totalAll !== 1 ? "s" : ""}`
              : `${requests.length} request${requests.length !== 1 ? "s" : ""}`}
          </span>
        </div>
      </div>

      {(item?.rate_admin_message || item?.rate_rejected_reason) && (
        <div
          style={{
            padding: "10px 14px",
            background: "#fff8e6",
            border: "1px solid #ffe08a",
            borderRadius: "8px",
            marginBottom: "14px",
            fontSize: "13px",
          }}
        >
          <strong>Last admin message:</strong> {item.rate_admin_message || item.rate_rejected_reason}
        </div>
      )}

      {requests.length === 0 ? (
        <div style={{ textAlign: "center", padding: "28px", color: "#6c757d" }}>
          No rate approval requests yet.
        </div>
      ) : (
        <div
          style={{
            padding: "12px",
            background: "linear-gradient(135deg, #f8f9ff 0%, #eef2ff 100%)",
            borderRadius: "10px",
          }}
        >
          {requests.map((req, idx) => (
            <SingleRequestPanel
              key={req.request_id || `${req.requested_at || req.submitted_at}-${idx}`}
              data={req}
              index={idx}
              totalCount={showOnlyFocused ? totalAll : requests.length}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default RateRequestProfile;
